export const PASSKEY_ENROLL_OFFER_ID = 'passkey';
